function PageSection({ title, description, stats }) {
  return (
    <main>
      <div className="mb-6 flex flex-wrap items-start justify-between gap-3">
        <div>
          <h1 className="ui-page-title">{title}</h1>
          <p className="ui-lead">{description}</p>
        </div>
        <div className="flex flex-wrap items-center gap-2">
          <span className="badge badge-primary badge-outline rounded-xl text-xs font-medium uppercase tracking-wide">
            Q2 Pipeline
          </span>
          <span className="badge badge-success badge-outline rounded-xl text-xs font-medium uppercase tracking-wide">
            Updated 5 min ago
          </span>
        </div>
      </div>

      <section className="grid gap-4 sm:grid-cols-2 xl:grid-cols-4">
        {stats.map((stat, index) => {
          const amount = 420 + index * 85;

          return (
            <article
              key={stat}
              className="ui-stat-block stat rounded-2xl border border-base-300 bg-base-100 shadow-sm"
            >
              <div className="stat-title">{stat}</div>
              <div className="stat-value text-primary">{amount}</div>
              <div className="stat-desc text-success">+12.4% from last month</div>
            </article>
          );
        })}
      </section>

      <section className="mt-6 grid gap-4 xl:grid-cols-3">
        <article className="card xl:col-span-2 rounded-2xl border border-base-300 bg-base-100 shadow-sm">
          <div className="card-body">
            <div className="mb-3 flex items-center justify-between gap-2">
              <h2 className="ui-panel-title">Recent Leads</h2>
              <button type="button" className="btn btn-ghost btn-sm rounded-lg ui-nav-text h-9 min-h-0 px-2 font-medium">
                View all
              </button>
            </div>
            <div className="overflow-x-auto">
              <table className="table table-zebra">
                <thead>
                  <tr>
                    <th className="ui-table-header">NAME</th>
                    <th className="ui-table-header">STATUS</th>
                    <th className="ui-table-header">OWNER</th>
                    <th className="ui-table-header">VALUE</th>
                  </tr>
                </thead>
                <tbody>
                  {['Acme Corp', 'Bright Labs', 'Nova Group'].map((lead, index) => (
                    <tr key={lead}>
                      <td className="ui-nav-text">{lead}</td>
                      <td>
                        <span
                          className={
                            index === 0
                              ? 'badge badge-success badge-outline rounded-xl'
                              : 'badge badge-info badge-outline rounded-xl'
                          }
                        >
                          {index === 0 ? 'Qualified' : 'Follow-up'}
                        </span>
                      </td>
                      <td className="ui-nav-text">
                        {index === 0 ? 'Sarah' : index === 1 ? 'Ahmed' : 'John'}
                      </td>
                      <td className="ui-nav-text tabular-nums">${(24 + index * 8).toFixed(1)}k</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </article>

        <article className="card rounded-2xl border border-base-300 bg-base-100 shadow-sm">
          <div className="card-body">
            <h2 className="ui-panel-title">Today&apos;s tasks</h2>
            <ul className="mt-3 space-y-1 rounded-xl bg-base-200/60 px-4 py-3">
              <li className="ui-nav-text py-2 leading-snug text-base-content/90">
                Follow up with top 5 leads
              </li>
              <li className="ui-nav-text py-2 leading-snug text-base-content/90">
                Review pending invoices
              </li>
              <li className="ui-nav-text py-2 leading-snug text-base-content/90">
                Team sync at 4:00 PM
              </li>
              <li className="ui-nav-text py-2 leading-snug text-base-content/90">
                Prepare monthly CRM report
              </li>
            </ul>
            <button type="button" className="btn btn-primary mt-5 w-full rounded-xl border-0 text-sm font-semibold shadow-sm">
              Create task
            </button>
          </div>
        </article>
      </section>
    </main>
  );
}

export default PageSection;
